'use client'

import * as React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { TableRow, TableCell } from '@/components/ui/table'

interface PostPurchaseRulesTableSkeletonProps {
	rows?: number
}

/**
 * PostPurchaseRulesTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export const PostPurchaseRulesTableSkeleton = ({ rows = 10 }: PostPurchaseRulesTableSkeletonProps) => {
	return (
		<SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
			<>
				{Array.from({ length: rows }, (_, index) => (
					<TableRow key={index}>
						{/* Select Checkbox */}
						<TableCell className="w-10">
							<Skeleton height={16} width={16} />
						</TableCell>

						{/* ID */}
						<TableCell className="w-24">
							<Skeleton height={20} width={80} />
						</TableCell>

						{/* Priority */}
						<TableCell className="w-24">
							<Skeleton height={20} width={60} borderRadius="0.375rem" />
						</TableCell>

						{/* Offers */}
						<TableCell className="w-32">
							<Skeleton height={16} width={80} />
						</TableCell>

						{/* Conditions */}
						<TableCell className="w-32">
							<Skeleton height={16} width={80} />
						</TableCell>

						{/* Operator */}
						<TableCell className="w-24">
							<Skeleton height={20} width={50} borderRadius="0.375rem" />
						</TableCell>

						{/* Created Date */}
						<TableCell className="w-32">
							<Skeleton height={14} width={100} />
						</TableCell>

						{/* Actions */}
						<TableCell className="w-10">
							<Skeleton height={32} width={32} borderRadius="0.25rem" />
						</TableCell>
					</TableRow>
				))}
			</>
		</SkeletonTheme>
	)
}

